<template>
  <NuxtLink
    :to="
      localePath({
        name: 'brands-product',
        params: { product: `${props.product?.attributes?.slug}` },
        query: {
          id: `${props.product?.id}`,
        },
      })
    "
    :title="`${props.product?.attributes?.name} - ${props.product?.attributes?.product_brand?.data?.attributes?.name}`"
    class="flex h-full w-full flex-[1_0_40%] flex-col items-center px-2 py-6 text-center text-n400 transition duration-200 ease-out hover:shadow-brandItem laptop:flex-[1_0_20%] desktop:flex-[1_0_15%]"
  >
    <div
      class="flex max-h-[210px] w-full shrink-0 justify-center overflow-hidden rounded-[4px] transition duration-200 ease-out"
    >
      <ImageStrapi :img="props.product?.attributes?.image" fit="contain" height="full" />
    </div>
    <div class="product-title mt-4 px-4" v-if="props.product?.attributes?.name">
      {{ props.product?.attributes?.name }}
    </div>
    <div class="product-description mt-6 px-4" v-if="props.product?.attributes?.short_description">
      {{ props.product?.attributes?.short_description }}
    </div>
    <div class="product-description mt-1.5 px-4" v-if="props.product?.attributes?.product_packagings?.data.length">
      {{ $t("product.availableSizes", props.product?.attributes?.product_packagings?.data.length) }}
    </div>
  </NuxtLink>
</template>
<script setup lang="ts">
import { ProductCardFragment } from "#gql";
const { t: $t } = useI18n();

const props = defineProps<{
  product?: ProductCardFragment | null | undefined;
}>();

const localePath = useLocalePath();
</script>
<style lang="scss" scoped></style>
